import { defineStore } from 'pinia';
import state from './state';
import type { IUser } from '@/interfaces/IUser';

export const useUserStore = defineStore('user', {
  state,
  actions: {
    updateUser(user: IUser) {
      this.user = user;
    },

    clearUser() {
      this.user = null;
    },

    updateProfileSetup(status: boolean) {
      this.profileSetup = status;
    },

    clearProfileSetup() {
      this.profileSetup = false;
    },
  },

  getters: {
    email: (state) => state.user?.email ?? '',
    firstName: (state) => state.user?.firstName ?? '',
    lastName: (state) => state.user?.lastName ?? '',
  },

  persist: true,
});
